import { localSave, session, localRead } from '@/libs/util'

export default {
  state: {
    userName: session.get('userName'),
    userId: session.get('userId'),
    userNum: session.get('userNum'),
    avatorImgPath: session.get('avatorImgPath'),
    token: localRead('token'),
    access: session.get('access'),
    hasGetInfo: session.get('hasGetInfo') ? session.get('hasGetInfo') : false
  },
  mutations: {
    setAvator (state, avatorPath) {
      state.avatorImgPath = avatorPath
    },
    setUserId (state, id) {
      state.userId = id
    },
    setUserName (state, name) {
      state.userName = name
    },
    setAccess (state, access) {
      state.access = access
    },
    setToken (state, token) {
      state.token = token
      localSave('token', token)
    },
    setLoginAt (state, loginAt) {
      state.loginAt = loginAt
      localSave('loginAt', loginAt)
    },
    setHasGetInfo (state, status) {
      state.hasGetInfo = status
    }
  },
  actions: {
    // 登录
    handleLogin ({ commit }, { phone, verifyCode }) {
      phone = phone.trim()
      return new Promise((resolve, reject) => {
        localSave('token', '')
        session.put('access', [])
      })
    },
    // 退出登录
    handleLogOut ({ state, commit }) {
      session.put('token', '')
      session.put('access', [])
      session.put('hasGetInfo', false)
      session.put('access', '')
      session.put('avator', '')
      session.put('userName', '')
      session.put('userId', '')
      session.put('shopId', '')
      session.clearAll()
    },
    // 获取用户相关信息
    getUserInfo ({ state, commit }) {
      console.log(result)
      session.put('avator', '')
      session.put('userName', 'admin')
      session.put('userId', 1)
      session.put('access', ['super_admin'])
      session.put('hasGetInfo', true)
    }
  }
}
